import React, { useEffect, useState } from "react";
import Table from "../../../components/table/Table";
import { useApiClient } from "../../../shared/customHooks";
import { finalisedListTable } from "../../../shared/tableObjects/admin/finalisedListTable";
import { PageHeader } from "../../../components/header/PageHeader";
import CreateApplicationButtonsManager from "../../../components/CreateApplicationButtonsManager";
import { RoleId } from "../../../shared/enums/Role";

export default function FinalisedList() {
  const apiClient = useApiClient("AdminApplication");

  const headerText = [
    {
      class: "p-0 m-0 flex items-center",
      value: "List of Finalised Assessments",
      icon: "list-icon icon-spec",
    },
  ];

  const { fetchData } = useApiClient("UserManagement", { identity: true });
  const [assessors, setAssessors] = useState<any>({ options: [] });

  useEffect(() => {
    fetchData(`GetActiveUsersByRoles/${RoleId.Assessor},${RoleId.Manager}`).then((res) => {
      const options = (res.data as any[]).map((user) => user.displayName).sort();
      setAssessors(options);
    });
  }, []);

  return (
    <>
      <PageHeader headerText={headerText} hideBreadcrumbs={true} icon={"icon"}></PageHeader>
      <div className="list-table">
        <CreateApplicationButtonsManager />{" "}
        <Table route="finalisedList" apiClient={apiClient} label={""} columns={finalisedListTable("finalised", assessors)} />
      </div>
    </>
  );
}
